import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/article/[id]/client.tsx");
